import { motion } from 'motion/react';

const PageHeader = ({ image, title, imageAlt = title }) => {
    return (
        <section className="relative flex md:h-[579px] h-[300px] w-full items-center justify-center overflow-hidden">
            <motion.img
                src={image}
                alt={imageAlt}
                className="absolute inset-0 h-full w-full object-cover"
                initial={{ scale: 1.08, opacity: 0.7 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
            />
            <div className="absolute inset-0 bg-black/25" aria-hidden="true" />
            <motion.h1
                className="relative z-10 px-4 text-center text-[40px] font-bold text-white"
                initial={{ opacity: 0, y: 28 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1.2, delay: 0.25, ease: [0.22, 1, 0.36, 1] }}
            >
                {title}
            </motion.h1>
        </section>
    );
};

export default PageHeader;
